import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookie from 'vue-cookie';
/*import 'bootstrap';*/
/*import 'mdbvue';*/
/*
import 'bootstrap/dist/css/bootstrap.min.css';
import 'mdbvue/build/css/mdb.css';
*/
//import './assets/styles/custom.scss';
import axios from 'axios';


Vue.prototype.$axios = axios;
Vue.config.devtools = true

Vue.config.productionTip = false
Vue.use(VueCookie);
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
